import format from 'date-fns/format';
import fetchData from '../../../modules/fetch_data';
// import moment from 'moment';

import { createSchema, getCurrentStore, processSessions } from './processors';

import { SetSessions } from './helpers';

export default async ({ url, items }, venue) => {
  const db = await fetchData(venue.slug, createSchema(venue), 1);
  const currentStore = getCurrentStore(venue);
  const setSessions = SetSessions(db, currentStore);
  const sessions = processSessions(items);
  // console.log('sessions', sessions)
  if (sessions.length > 0) {
    await setSessions(sessions, sessions[0].start);
  }

  return {
    db,
    currentStore,
    sessions,
  };
};
